import React from 'react';

interface AnimatedTextProps {
    text: string;
    offsets: { x: number; y: number }[];
    animated: boolean;
    className?: string;
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
}

export const AnimatedText: React.FC<AnimatedTextProps> = ({ 
    text, 
    offsets, 
    animated, 
    className = '', 
    as: Component = 'span' 
}) => {
    const content = (() => {
        let charIndex = 0;
        return text.split(' ').map((word, wordIndex) => {
            const wordElement = (
                <span key={wordIndex} className="inline-block whitespace-nowrap" style={{ marginRight: '0.25em' }}>
                    {word.split('').map((char, idx) => {
                        const offset = offsets[charIndex];
                        charIndex++;
                        
                        return (
                            <span
                                key={idx}
                                className={`inline-block title-letter ${
                                    animated ? 'animate-letter-align' : 'letter-scrambled'
                                }`}
                                style={{
                                    '--random-x': `${offset?.x || 0}px`,
                                    '--random-y': `${offset?.y || 0}px`
                                } as React.CSSProperties}
                            >
                                {char}
                            </span>
                        );
                    })}
                </span>
            );
            // Account for space character
            if (wordIndex < text.split(' ').length - 1) {
                charIndex++;
            }
            return wordElement;
        });
    })();

    return <Component className={className}>{content}</Component>;
};

